import api from './axios';
import axios from 'axios';

export const investmentAPI = {
  // POST /api/investment/create-order — create Razorpay order (amount ≤ 2500)
  createOrder: (data) => api.post('/investment/create-order', data),

  // POST /api/investment/verify-payment — verify payment & save investment
  verifyPayment: (data) => api.post('/investment/verify-payment', data),

  // POST /api/investment/manual-deposit — manual bank transfer deposit (amount > 2500)
  manualDeposit: (data) => api.post('/investment/manual-deposit', data),

  // GET /api/investment/history
  getHistory: (params) => api.get('/investment/history', { params }),

  // GET /api/investment/balance
  getBalance: () => api.get('/investment/balance'),
};

// Public endpoint — no auth needed
const baseURL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';
export const getCompanyBankAccount = () =>
  axios.get(`${baseURL}/company-bank-account`, { headers: { Accept: 'application/json' } });
